interface ActivQMSLoaderProps {
  size?: "sm" | "md" | "lg" | "xl";
  text?: string;
  showText?: boolean;
  className?: string;
}

export function ActivQMSLoader({
  size = "md",
  text = "Loading...",
  showText = true,
  className = "",
}: ActivQMSLoaderProps) {
  const sizeClasses = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-12 h-12",
    xl: "w-16 h-16",
  };

  const textSizeClasses = {
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg",
    xl: "text-xl",
  };

  return (
    <div
      className={`flex flex-col items-center justify-center space-y-3 ${className}`}
    >
      {/* Favicon with spinning border */}
      <div className={`relative ${sizeClasses[size]}`}>
        {/* Spinning border */}
        <div className="absolute inset-0 rounded-full border-2 border-gray-200"></div>
        <div className="absolute inset-0 rounded-full border-2 border-brand-500 border-t-transparent animate-spin"></div>

        {/* Favicon image in center */}
        <div className="absolute inset-0 flex items-center justify-center p-2">
          <img
            src="/favicon.png"
            alt="activQMS"
            className="w-full h-full object-contain"
          />
        </div>
      </div>

      {/* Loading text */}
      {showText && (
        <p className={`text-gray-600 font-medium ${textSizeClasses[size]}`}>
          {text}
        </p>
      )}
    </div>
  );
}

// Full screen loader overlay
export function ActivQMSFullScreenLoader({
  text = "Loading activQMS...",
}: {
  text?: string;
}) {
  return (
    <div className="fixed inset-0 bg-white z-50 flex items-center justify-center">
      <div className="text-center">
        <ActivQMSLoader size="xl" text={text} />

        <div className="mt-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">activQMS</h1>
          <p className="text-gray-600 text-sm">Quality Management System</p>
        </div>
      </div>
    </div>
  );
}

// Skeleton loader for content
export function ActivQMSSkeletonLoader() {
  return (
    <div className="animate-pulse space-y-4">
      <div className="h-8 bg-gray-200 rounded-lg w-3/4"></div>
      <div className="space-y-2">
        <div className="h-4 bg-gray-200 rounded w-full"></div>
        <div className="h-4 bg-gray-200 rounded w-5/6"></div>
        <div className="h-4 bg-gray-200 rounded w-4/6"></div>
      </div>
      <div className="grid grid-cols-3 gap-4">
        <div className="h-20 bg-gray-200 rounded-lg"></div>
        <div className="h-20 bg-gray-200 rounded-lg"></div>
        <div className="h-20 bg-gray-200 rounded-lg"></div>
      </div>
    </div>
  );
}
